export default __webpack_public_path__ + "static/media/Megosu - Made.com - 6.e7609a79.jpg";